import React from 'react';
import GLink from '../GLink';
import GCountdown from './GCountdown';

type Props = {
  link: string;
  external?: boolean;
  name: string;
  iframe?: boolean;
  img?: string;
  author: Author;
  price: number | string;
  unit: string;
  favor: string;
  expire?: string | number | Date;
  btnText: string;
  btnColor?: 'danger' | 'success' | 'info';
  link2?: string;
  name2?: string;
};

type Author = {
  name: string;
  avatar: string;
  link: string;
};

const ProductItem = ({
  link,
  link2,
  external = false,
  name,
  name2,
  iframe,
  img,
  price,
  unit,
  author,
  favor,
  expire,
  btnText,
  btnColor = 'info',
}: Props) => {
  return (
    <div className="product-item rounded position-relative">
		<h3 className="product-title mb-3">
		{link2 && name2 ? (
		<>
		<GLink external={external} href={link}>{name}</GLink>
		{' '}|{' '}
		<GLink external={external} href={link2}>{name2}</GLink>
		</>
		) : (
			<GLink external={external} href={link}>{name}</GLink>
			)
		}
		</h3>

      <div className="product-img position-relative overflow-hidden mb-4 rounded">
        {iframe ? (
          <iframe src={link} title={name} height="300" loading="lazy" />
        ) : (
          <GLink external={external} href={link}>
            <img className="img-fluid w-100" src={img} alt="" />
          </GLink>
        )}
        {expire && (
          <div className="product-time d-inline-block">
            <GCountdown expire={expire} />
          </div>
        )}
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <div className="product-author d-flex align-items-center">
          <img className="img-fluid rounded me-2" src={author.avatar} alt="" />
          <GLink external={true} href={author.link}>
            {author.name}
          </GLink>
        </div>
        <GLink external={external} href="#" className="like-area ms-1">
          <i className="bi bi-heart"></i>
          {favor}&nbsp;
        </GLink>
      </div>
      <div className="product-info border-top border-dark border-dashed pt-3 mt-3 d-flex align-items-center justify-content-between">
        <GLink external={external} href={link} className={`btn-bid btn btn-outline-${btnColor} btn-sm`}>
          {btnText}
        </GLink>
        <div className="product-price">
          <span className="d-block mb-1">{unit}</span> <span>{price}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
